import {Injectable, inject, signal, WritableSignal} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom} from "rxjs";

@Injectable({providedIn: "root"})
export class LoadingService {
    private translate: TranslateService = inject(TranslateService);

    public loading: WritableSignal<boolean> = signal<boolean>(false);
    public loadingMessage: WritableSignal<string> = signal<string>(undefined);

    private actionTimeout: ReturnType<typeof setTimeout>;

    constructor() {
        console.log("--- LoadingService");
    }

    public async performWithSpinner<T>(action: () => Promise<T>, duration: number = 10000, messageKey?: string, messageParams?: Record<string, string | number>, dismissAfterAction: boolean = true): Promise<T> {
        if (duration > 0) {
            await this.startSpinner(duration, messageKey, messageParams);
        }
        try {
            const loadResult: T = await action();
            if (dismissAfterAction) {
                this.dismissSpinner();
            }
            return loadResult;
        } catch (error) {
            this.dismissSpinner();
            throw error;
        }
    }

    public async startSpinner(duration: number = 10000, messageKey?: string, messageParams?: Record<string, string | number>): Promise<void> {
        const message: string = messageKey ? await firstValueFrom(this.translate.get(messageKey, messageParams)) : undefined;
        this.clearTimeout();
        this.loading.set(true);
        this.loadingMessage.set(message);
        if (duration) {
            this.actionTimeout = setTimeout(() => this.dismissSpinner(), duration);
        }
    }

    public dismissSpinner(): void {
        this.clearTimeout();
        this.loading.set(false);
        this.loadingMessage.set(undefined);
    }

    private clearTimeout(): void {
        if (this.actionTimeout) {
            clearTimeout(this.actionTimeout);
            this.actionTimeout = undefined;
        }
    }
}
